/*
  Message Box Types
  info
  error
  success
  warning
*/

import React from "react";

type Props = {
  type: string,
  title?: string,
  content: string
}

const MessageBox : React.FC<Props> = ({ type, title, content }) => {
  return (
    <div className="message-box-wrapper">
      <div className={`message-box message-box--${type}`}>
        {title && (
          <>
            <div className="message-box__heading">
              <span className="fa fa-info-circle message-box__icon"></span>
              <strong className="message-box__title h3">{title}</strong>
            </div>
            <hr className="message-box__rule" />
          </>
        )}
        <div className="message-box__copy">
          <p>{content}</p>
        </div>
      </div>
    </div>
  );
};

export default MessageBox;
